// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import type { Image, PersistedImage, Crop } from '../../types'

const linkColor = '#3b78ca'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 10px 20px;
  width: 270px;
  border: 1px solid #cecece;
  background: #fff;
`
const MainBlock: StyledComponent<Object, any, any> = styled.div`
  display: flex;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  color: ${linkColor};
  font-family: Arial, sans-serif;
  font-size: 13px;
  line-height: 13px;
  padding-bottom: 6px;
`
const ImageBlock: StyledComponent<Object, any, any> = styled.div`
  width: 90px;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  color: #777;
  font-family: Arial, sans-serif;
  font-size: 13px;
  line-height: 12px;
  padding-left: 10px;
`
const Url: StyledComponent<Object, any, any> = styled.div`
  font-size: 12px;
  color: ${linkColor};
  padding-top: 3px;
`

type Props = {|
  title: string,
  description: string,
  image: ?Image | ?PersistedImage,
  imageCrop: ?Crop,
  url: string
|}

export default function TmPreview(props: Props) {
  const { title, description, image, imageCrop, url } = props

  return (
    <Wrapper>
      <Title>{title}</Title>
      <MainBlock>
        <ImageBlock>
          <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={90} ratio={1.2} />
        </ImageBlock>
        <Text>{description}</Text>
      </MainBlock>
      <Url>{url}</Url>
    </Wrapper>
  )
}
